import {
  SectionHeading,
  SelectField,
  TextField,
} from "@via/pages/projects/metadata/configuration/data-import/components/fields";
import type { ImportFormValues } from "@via/pages/projects/metadata/configuration/data-import/utils/form";
import type { FC } from "react";

const SourceSection: FC<{
  values: ImportFormValues;
  onChange: (patch: Partial<ImportFormValues>) => void;
}> = ({ values, onChange }) => (
  <section aria-labelledby="import-source-heading" className="space-y-4">
    <SectionHeading
      id="import-source-heading"
      title="Source"
      description="Where the records come from, and how to page through them."
    />
    <TextField
      id="import-api-url"
      label="API URL"
      value={values.apiUrl}
      onChange={apiUrl => onChange({ apiUrl })}
    />
    <SelectField
      id="import-api-method"
      label="Method"
      value={values.apiMethod}
      onChange={apiMethod =>
        onChange({ apiMethod: apiMethod === "POST" ? "POST" : "GET" })
      }
      options={[
        { value: "GET", label: "GET" },
        { value: "POST", label: "POST" },
      ]}
    />
    <TextField
      id="import-data-location"
      label="Data location"
      value={values.dataLocation}
      hint="Dotted path to the list of records in the response, for example data.items. Leave blank when the response is the list."
      onChange={dataLocation => onChange({ dataLocation })}
    />
    <TextField
      id="import-next-page-location"
      label="Next page location"
      value={values.nextPageLocation}
      hint="Response field that holds the next page value, if the API provides one."
      onChange={nextPageLocation => onChange({ nextPageLocation })}
    />
    <TextField
      id="import-next-page-parameter"
      label="Next page parameter"
      value={values.nextPageParameter}
      hint="Query parameter the next page value is sent in, for example page."
      onChange={nextPageParameter => onChange({ nextPageParameter })}
    />
  </section>
);

export default SourceSection;
